import { Regime } from "@/types/company";

export const mapCompanySizeToLabel = (companySize: Regime) => {
  switch (companySize) {
    case "PYME":
      return "Pequeña y mediana empresa";
    case "LARGE_COMPANY":
      return "Grande";
    default:
      return "Desconocido";
  }
};
